export interface User {
    id?: string;
    firstName: string;
    lastName: string;
    title: string;
    phoneNumber: string;
    email: string;
    avatarLink: string;
    tenantId?: number;
}

export interface UserAvatar {
    avatarId?: string;
    avatarDataUriContent?: string;
}

export interface UserFormValues extends User {}

export interface PasswordResetFormValues {
    newPassword: string;
    confirmPassword: string;
}

export enum ProfileTabs {
    CONTACT_INFORMATION = 'CONTACT INFORMATION',
    PASSWORD_RESET = 'PASSWORD MANAGEMENT',
}

export interface ValidationRule {
    message: string;
    regex: RegExp | null;
    isSubRule?: boolean;
}

export const ruleSeparatorMessage = 'At least 3 of the following:';
export const passwordRules: Array<ValidationRule> = [
    {
        regex: /.{8,}/,
        message: 'At least 8 characters',
    },
    {
        regex: null,
        message: ruleSeparatorMessage,
    },
    {
        regex: /[a-z]/,
        message: 'Lower case letters (a-z)',
        isSubRule: true,
    },
    {
        regex: /[A-Z]/,
        message: 'Upper case letters (A-Z)',
        isSubRule: true,
    },
    {
        regex: /[0-9]/,
        message: 'Numbers (0-9)',
        isSubRule: true,
    },
    {
        regex: /[!@#$%^&*()_+\-=;'",.<>/?]/,
        message: 'Special characters (e.g. !@#$%^&*)',
        isSubRule: true,
    },
];
